import axios from "axios";

export default {
  name: "reconciliation",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getcashonbankdata(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "cash_on",
          params: {tlc : auth.username},
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getcashonbanklist(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "main/bank_account",
          params: {tlc : auth.username},
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    savebankAccount(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getManifestCashonbank(store, { kode_bank,periode }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "cash_on/bank",
          params: { 
            tlc: store.getters.getAuth.username, kode_bank:kode_bank, 
            periode: periode},
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getManifestCashonhand(store, { pic_kas_kecil }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "cash_on/hand",
          params: { 
            tlc: store.getters.getAuth.username, 
            pic_kas_kecil: pic_kas_kecil},
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
